// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__jn1nI","header":"Panel_header__eZQ+h","title":"Panel_title__1-aQ8","content":"Panel_content__FyR0u"};